import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CityData } from '../../shared/components/city-modal/interfaces/city.interface';
import { ConfigService } from '../../shared/services/config.service';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private locationSubject: BehaviorSubject<CityData | null>;
  location$;

  constructor(private configService: ConfigService) {
    this.locationSubject = new BehaviorSubject<CityData | null>(
      this.getLocation()
    );
    this.location$ = this.locationSubject.asObservable();
  }

  getLocation(): CityData | null {
    const locationStr = sessionStorage.getItem(this.storageKey);
    return locationStr ? JSON.parse(locationStr) : null;
  }

  setLocation(cityData: CityData): void {
    sessionStorage.setItem(this.storageKey, JSON.stringify(cityData));
    this.locationSubject.next(cityData);
  }

  hasLocation(): boolean {
    return this.getLocation() !== null;
  }

  getApiUrl(): string | null {
    const location = this.getLocation();
    return location?.apiWebURL ?? null;
  }

  private get storageKey(): string {
    return this.configService.getStorageConfig().userLocationKey;
  }
}
